import API from 'services/API';

// Structures

export const getAllStructureAdmin = () => API.get(`/cooperatives?version=superAdmin_structures`);

export const getAllUserFunctionalityRights = () => API.get(`/user/functionality/right`);

export const getAllStructureRoleFunctionalityRights = () => API.get(`/level/functionality/right`);

export const patchUserFunctionalityRights = (data) => API.post(`/user/functionality/right`, data);

export const patchStructureRoleFunctionalityRights = (data) =>
  API.post(`/level/functionality/right`, data);

export const deleteUserFunctionalityRights = (userFunctionalityRightId) =>
  API.delete(`/user/functionality/right/${userFunctionalityRightId}`);

export const deleteStructureRoleFunctionalityRights = (structureRoleFunctionalityRightId) =>
  API.delete(`/level/functionality/right/${structureRoleFunctionalityRightId}`);

export const getAllFunctionalities = () => API.get(`/functionalities`);

export const addStructure = (structure) =>
  API.post(`/cooperatives/add`, structure, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const updateStructure = (editStructure, id) =>
  API.post(`/cooperatives/edit/${id}`, editStructure, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const removeStructure = (id) => API.delete(`/cooperatives/remove/${id}`);

export const addNewAdmin = (admin) => API.post('/users/add', admin);

export const removeAdmin = (id) => API.delete(`/users/remove/${id}`);

// Tools

export const getAppDate = () => API.get('/tools/system-clock');

export const updateAppDate = (date) => API.post('/tools/system-clock', date);

// Pacage exclusion

export const getPacageExclusion = () => API.get(`/pacage-exclusions`);

export const addPacageExclusion = (pacageExclusion) =>
  API.post(`/pacage-exclusions/add`, pacageExclusion);

export const updatePacageExclusion = (pacageExclusion) =>
  API.patch(`/pacage-exclusions/edit/${pacageExclusion.id}`, pacageExclusion);

export const deletePacageExclusion = (pacageExclusionId) =>
  API.delete(`/pacage-exclusions/remove/${pacageExclusionId}`);
